import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './AuthContext';
import MatrimonyNavbar from './MatrimonyNavbar';
import MatrimonyHome from './pages/MatrimonyHome';
import MatrimonyProfiles from './pages/MatrimonyProfiles';
import MatrimonyProfileDetail from './pages/MatrimonyProfileDetail';
import MatrimonyRegister from './pages/MatrimonyRegister';
import MatrimonyLogin from './pages/MatrimonyLogin';
import MatrimonyDashboard from './pages/MatrimonyDashboard';
import MatrimonyAdmin from './pages/MatrimonyAdmin';
import './matrimony.css';

export default function MatrimonyApp() {
  return (
    <div className="matrimony-root">
      <AuthProvider>
        <BrowserRouter basename="/app/matrimony">
          <MatrimonyNavbar />
          <Routes>
            <Route path="/"             element={<MatrimonyHome />} />
            <Route path="/profiles"     element={<MatrimonyProfiles />} />
            <Route path="/profiles/:id" element={<MatrimonyProfileDetail />} />
            <Route path="/register"     element={<MatrimonyRegister />} />
            <Route path="/login"        element={<MatrimonyLogin />} />
            <Route path="/dashboard"    element={<MatrimonyDashboard />} />
            <Route path="/admin"        element={<MatrimonyAdmin />} />
            <Route path="*"             element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}
